import React, { Suspense, lazy } from "react";
import ReactDOM from "react-dom/client";
import reportWebVitals from "./reportWebVitals";
import { ThemeProvider } from "@emotion/react";
import { CssBaseline } from "@mui/material";
import Loader from "src/components/loader";
import SnackBar from "src/components/snackbar";
import PageLoadingSkeleton from "src/components/page-loading-skeleton";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import StoreProvider from "src/redux/store-provider";
import theme from "src/theme";
import Navbar from "./components/navbar";

const Login = lazy(() => import("src/apps/auth/pages/login"));
const Landing = lazy(() => import("src/apps/landing/pages"));

const Customers = lazy(() => import("src/apps/customers/pages"));
const CustomerDetail = lazy(() => import("src/apps/customers/pages/detail"));
const CustomerDetailIndex = lazy(
  () => import("src/apps/customers/pages/details/index")
);
const CustomerDetailLedger = lazy(
  () => import("src/apps/customers/pages/details/ledger")
);
// const CustomerLedgerPrint = lazy(
//   () => import("src/apps/customers/pages/ledger-print")
// );
const Suppliers = lazy(() => import("src/apps/suppliers/pages"));
const SupplierDetail = lazy(() => import("src/apps/suppliers/pages/detail"));
const GenerateSupplierInvoice = lazy(() => import("src/apps/suppliers/pages/new-supplier-invoice"));
const Staff = lazy(() => import("src/apps/staff/pages"));
const StaffDetail = lazy(() => import("src/apps/staff/pages/detail"));

const Accounts = lazy(() => import("src/apps/accounts/pages/accounts"));
const AccountDetails = lazy(
  () => import("src/apps/accounts/pages/accounts/details")
);
const PaymentMethods = lazy(
  () => import("src/apps/accounts/pages/payment-method")
);
const PaymentMethodDetails = lazy(
  () => import("src/apps/accounts/pages/payment-method/details")
);
const PaymentLabels = lazy(() => import("src/apps/accounts/pages/labels"));
const PaymentLabelDetails = lazy(
  () => import("src/apps/accounts/pages/labels/details")
);
const AccountingOverview = lazy(
  () => import("src/apps/accounts/pages/overview")
);

const Products = lazy(() => import("src/apps/inventory/pages/"));
const ProductDetails = lazy(
  () => import("src/apps/inventory/pages/detail")
);
// const Category = lazy(() => import("src/apps/inventory/pages/category"));
// const CategoryDetail = lazy(
//   () => import("src/apps/inventory/pages/category/detail")
// );

const SalesStats = lazy(() => import("src/apps/reports/pages/sales-stats"));
const DayReport = lazy(() => import("src/apps/reports/pages/day"));
const GSTReport = lazy(() => import("src/apps/reports/pages/gst"));
const Calendar = lazy(() => import("src/apps/reports/pages/calendar"));
const AreaReport = lazy(() => import("src/apps/reports/pages/area"));

const NewBill = lazy(() => import("src/apps/billing/pages/new"));
// const EditBill = lazy(() => import("src/apps/billing/pages/edit"));
const OldBill = lazy(() => import("src/apps/billing/pages/old"));
const OldBillDetail = lazy(() => import("src/apps/billing/pages/old-detail"));
const OldBillPrint = lazy(() => import("src/apps/billing/pages/print"));
// const ViewVoucher = lazy(() => import("src/apps/billing/pages/vouchers"));
// const UpdateVoucher = lazy(
//   () => import("src/apps/billing/pages/vouchers/update")
// );
// const NewVoucher = lazy(() => import("src/apps/billing/pages/vouchers/new"));
// const DiscountCoupons = lazy(
//   () => import("src/apps/billing/pages/discount-coupons")
// );
// const DiscountCouponDetails = lazy(
//   () => import("src/apps/billing/pages/discount-coupons/detail")
// );

const BillLayout = lazy(
  () => import("src/apps/store-management/pages/bill-layout")
);
// const TagLayout = lazy(
//   () => import("src/apps/store-management/pages/tag-layout")
// );
// const Settings = lazy(() => import("src/apps/store-management/pages/settings"));
// const AuditLog = lazy(
//   () => import("src/apps/store-management/pages/audit-log")
// );

// const TagPrint = lazy(() => import("src/apps/landing/pages/tag"));

const routes = [
  {
    path: "",
    element: <Navbar />,
    children: [
      {
        path: "",
        element: <Landing />,
      },
      // {
      //   path: "tag-print",
      //   element: <TagPrint />,
//      },
      {
        path: "/login",
        element: <Login />,
      },

      // {
      //   path: "print-ledger/:id",
      //   element: <CustomerLedgerPrint />,
      // },

      {
        path: "people",
        children: [
          {
            path: "customers",
            element: <Customers />,
            children: [
              {
                path: ":id",
                element: <CustomerDetail />,
                children: [
                  {
                    path: "",
                    element: <CustomerDetailIndex />,
                  },
                  {
                    path: "ledger",
                    element: <CustomerDetailLedger />,
                  },
                ],
              },
            ],
          },
          {
            path: "suppliers",
            element: <Suppliers />,
            children: [
              {
                path: ":id",
                element: <SupplierDetail />,
              },
            ],
          },
          {
            path: "staff",
            element: <Staff />,
            children: [
              {
                path: ":id",
                element: <StaffDetail />,
              },
            ],
          },
        ],
      },

      {
        path: "accounting",
        children: [
          {
            path: "accounts",
            element: <Accounts />,
            children: [
              {
                path: ":id",
                element: <AccountDetails />,
              },
            ],
          },
          {
            path: "methods",
            element: <PaymentMethods />,
            children: [
              {
                path: ":id",
                element: <PaymentMethodDetails />,
              },
            ],
          },
          {
            path: "labels",
            element: <PaymentLabels />,
            children: [
              {
                path: ":id",
                element: <PaymentLabelDetails />,
              },
            ],
          },
          {
            path: "overview",
            element: <AccountingOverview />,
          },
        ],
      },
      {
        path: "inventory",
        children: [
      //     {
      //       path: "overview",
      //       element: <Overview />,
      //     },
      //     {
      //       path: "verify",
      //       element: <VerifyTags />,
      //     },
      //     {
      //       path: "purities",
      //       element: <Purities />,
      //     },
          {
            path: "products",
            element: <Products />,
            children: [
              {
                path: ":id",
                element: <ProductDetails />,
              },
            ],
          },
      //     {
      //       path: "categories",
      //       element: <Category />,
      //       children: [
      //         {
      //           path: ":id",
      //           element: <CategoryDetail />,
      //         },
      //       ],
      //     },
          {
            path: "add",
            element: <GenerateSupplierInvoice />,
          },
      //     {
      //       path: "view-bill/:id",
      //       element: <ViewInventoryBill />,
      //     },
      //     {
      //       path: "tag-info",
      //       element: <TagInfo />,
      //     },
        ],
      },
      {
        path: "billing",
        children: [
          {
            path: "new",
            element: <NewBill />,
          },
      //     {
      //       path: "edit",
      //       element: <EditBill />,
      //     },
          {
            path: "old",
            element: <OldBill />,
            children: [
              {
                path: ":id",
                element: <OldBillDetail />,
              },
            ],
          },
          {
            path: "print/:id",
            element: <OldBillPrint />,
          },
      //     {
      //       path: "vouchers",
      //       children: [
      //         {
      //           path: "",
      //           element: <ViewVoucher />,
      //           children: [
      //             {
      //               path: ":id",
      //               element: <UpdateVoucher />,
      //             },
      //           ],
      //         },
      //         {
      //           path: "new",
      //           element: <NewVoucher />,
      //         },
      //       ],
      //     },
      //     {
      //       path: "discount-coupons",
      //       element: <DiscountCoupons />,
      //       children: [
      //         {
      //           path: ":id",
      //           element: <DiscountCouponDetails />,
      //         },
      //       ],
      //     },
        ],
      },
      {
        path: "reports",
        children: [
          {
            path: "sales",
            element: <SalesStats />,
          },
          {
            path: "day",
            element: <DayReport />,
          },
          {
            path: "gst",
            element: <GSTReport />,
          },
          {
            path: "calendar",
            element: <Calendar />,
          },
          {
            path: "area",
            element: <AreaReport />,
          },
        ],
      },
      {
        path: "store",
        children: [
          {
            path: "bill-layout",
            element: <BillLayout />,
          },
      //     {
      //       path: "tag-layout",
      //       element: <TagLayout />,
      //     },
      //     {
      //       path: "settings",
      //       element: <Settings />,
      //     },
      //     {
      //       path: "audit-log",
      //       element: <AuditLog />,
      //     },
        ],
      },
    ],
  },
];

const router = createBrowserRouter(routes);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <StoreProvider>
        <Loader />
        <SnackBar />
        <Suspense fallback={<PageLoadingSkeleton />}>
          <RouterProvider router={router} />
        </Suspense>
      </StoreProvider>
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
